var module = angular.module('components');
module.component('caAddress', {
    templateUrl: 'components/genericcomponents/address.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        address: '=',
        isEditing: '<',
        removeAddress: '&',
        showTools: '<'
    },
    controller: [addressController]
});

function addressController() {
    var vm = this;

    vm.remove = remove;
    if (vm.showTools === undefined) { vm.showTools = true; }

    function remove() {
        vm.removeAddress();
    }
}
